import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import FormContainer from "../components/FormContainer";
import PasswordChecker from "../components/PasswordChecker";
import axios from "axios";
import Message from "../components/Message";
import { notify } from "../components/notify";
import { Howl } from "howler";

const PasswordRecoveryScreen = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const userId = params.userId;
  const [token, setToken] = useState(searchParams.get("token"));

  const [updatedUser, setUpdatedUser] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const updatePassword = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `/api/users/${userId}/updateUserPassword`,
        { password },
        config,
      );

      setUpdatedUser(data);
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      setError(message);
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match");
    } else {
      updatePassword();
    }
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (updatedUser) {
      notify({
        title: "Update Success",
        message: <p className="lead">Changes updated successfully 👏👏.</p>,
        type: "success",
        duration: 3000,
      });
      var sound = new Howl({
        src: `/success.mp3`,
      });
      sound.play();

      navigate("/login-screen");
    }
  }, [updatedUser, token]);

  return (
    <FormContainer>
      <Form onSubmit={submitHandler}>
        <h3>Change Password</h3>

        <Form.Group controlId="password">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Enter New Password"
            value={password}
            autoComplete="new-password"
            onChange={(e) => setPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <PasswordChecker password={password} />

        <Form.Group controlId="confirmPassword">
          <Form.Label>Confirm Password</Form.Label>
          <Form.Control
            type="password"
            placeholder="Confirm password"
            value={confirmPassword}
            autoComplete="new-password"
            onChange={(e) => setConfirmPassword(e.target.value)}
          ></Form.Control>
        </Form.Group>
        {message && <Message children={message} />}
        {error && <Message children={error} variant={`danger`} />}
        <Button
          className="btn btn-info"
          style={{ float: "right" }}
          type="submit"
        >
          Update Details
        </Button>
      </Form>
    </FormContainer>
  );
};

export default PasswordRecoveryScreen;
